import classNames from 'classnames';

import Video from '../partials/Video';

import styles from '../../styles/blocks/video-block.module.css';

interface VideoBlockProps {
    media: Video;
    className?: string | null;
}

function VideoBlock({ media, className = null }: VideoBlockProps) {
    const { width = 0, height = 0 } = media || {};
    const vertical = height > width;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.vertical]: vertical,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([styles.shape, 'contain-size'])}
                style={{
                    paddingBottom: `${(height / width) * 100}%`,
                }}
            >
                {media !== null ? (
                    <Video media={media} nativeControls className={styles.video} withoutBlock />
                ) : null}
            </div>
        </div>
    );
}

export default VideoBlock;
